import { render } from "./normal.md?vue&type=template&id=4a2bc7ba"
import script from "./normal.md?vue&type=script&lang=js"
export * from "./normal.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__